<template>
  <div>
    <TopBar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1">
        </div>
        <div class="col-sm-3" style="padding:20px;">
          <MenuSetup />
        </div>
        <div class="col-sm-7">
          <div style="margin-top:30px;">
            <form>
              <div class="form-group row">
                <label for="imgprog" class="col-sm-3 col-form-label aright">{{ $t('programmer') }}</label>
                <div class="col-sm-9">
                  <div class="prog_control" style="padding-top:8px;">
                      <input class="prog_state" type="image" src="https://img.intratone.info/icon/etat/1.png" name="imgprog" id="imgprog" onclick="Prog.information();" style="float:left; margin:0 5px; width:auto;">
                      <img class="prog_type" style="float:left; margin:0 10px; width:auto; margin-left:10px; height:20px;" id="typeprog" src="https://img.intratone.info/Images/Programmateur/prog_usb2.png" onclick="Prog.information();">
                      <div style="clear:both;"></div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="serialgrave" class="col-sm-3 col-form-label aright">
                  <div class="stick-icon"></div>
                </label>
                <div class="col-sm-3">
                  <input type="text" class="form-control badgegrave" id="serial" name="serial" >
                </div>
              </div>
            </form>
            <div class="alert alert-info" style="width: 70%; margin: 20px auto;">
              {{ $t('putEtikronicOnProg') }}
            </div>
          </div>
        </div>
        <div class="col-sm-1">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import MenuSetup from './MenuSetup.vue'

export default {
  name: 'Etiktronic',
  components: {
      TopBar,
      MenuSetup
  },
  data: function() {
    return {
      system : false,
      nav : false,
      appli : '',
      prog : false
    }
  },
  created: function () {
    let self = this;
    document.title = this.$i18n.t(`readAnEtikronic`);
    setTimeout(function(){
      self.runReadEtiktronic();
    },300);
  },
  beforeDestroy(){
    Prog.close();
  },
  methods : {
    runReadEtiktronic(){
      //alert('runReadBadge');
      Prog.install();
      Prog.init(function (d) {
          proglib.etiquette.lire();
      });
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aright {
    text-align: right;
}
.steps {
  text-align: left;
  margin:30px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
}
.bimg {
  height: 50px;
}
a:hover h3 {
  color: #043967;
}
.step {
  margin:10px 20px;
}
.stepi {
  height: 24px;
}
a.act {
    margin: 10px auto;
    width: auto;
    padding: 10px;
    display: block;
    color : grey;
    background: #f8f8f8;
    border-radius: 10px;
    text-align: center;
    text-decoration: none;
}
a.act:hover {
    background: #eee;
    color : #08c;
    text-decoration: none;
}
a.act span {
    display: block;
}
a.act img {
    height: 50px;
}
</style>
